import '@/index.css'
import 'animate.css'

import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import { App } from './app'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
